import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";


  const rootElement = document.getElementById("chat-widget-root");

// Detect if chatbot should be suppressed
// based on URL parameters and display modem in this case a query parameter ?source=pwa should be passe to called url
const queryParams = new URLSearchParams(window.location.search);
const suppressChatbot =
  queryParams.get("source") === "chatbot" &&
  (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true);
// Check if the chatbot is disabled via data attribute, in this case the html that injects (embeds) chatbot should look like this:<div id="chat-widget-root" data-disable-chatbot="true"></div>
const shouldDisable = rootElement?.dataset?.disableChatbot === "true";


if (!suppressChatbot && !shouldDisable && rootElement) {
    ReactDOM.createRoot(rootElement).render(<App />);
} else if (!rootElement) {
    console.error('❌ Element with ID "chat-widget-root" not found.');
} else {
  console.log("🚫 Chatbot suppressed inside standalone PWA with source=pwa");
  }
